import { render, staticRenderFns } from "./ConfigurazioneContabilitaTipiSoggettiListComponent.vue?vue&type=template&id=17247ad3&scoped=true"
import script from "./ConfigurazioneContabilitaTipiSoggettiListComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurazioneContabilitaTipiSoggettiListComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfigurazioneContabilitaTipiSoggettiListComponent.vue?vue&type=style&index=0&id=17247ad3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17247ad3",
  null
  
)

export default component.exports